// third party
import { createSlice } from '@reduxjs/toolkit';
import { FormikValues } from 'formik';

// project imports
// import axios from 'utils/axios';
import axios, { AxiosRequestConfig } from 'axios';
import { dispatch } from '../index';

// types
import { DefaultRootStateProps } from 'types';

// ==============================|| SLICE - CALENDAR ||============================== //

const hostDomain = 'https://mock-data-api-nextjs.vercel.app';
const config: AxiosRequestConfig = {
  headers: {
    Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI1ZTg2ODA5MjgzZTI4Yjk2ZDJkMzg1MzciLCJpYXQiOjE3NDcyMTQ3MzcsImV4cCI6MTc0NzMwMTEzN30.VmUHjc8hwALgUuryrrOT34gozC82QKtr-DD5w5JuePU`,
  },
};

const initialState: DefaultRootStateProps['calendar'] = {
  error: null,
  events: [],
};

const slice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    // GET EVENTS
    getEventsSuccess(state, action) {
      state.events = action.payload;
    },

    // ADD EVENT
    addEventSuccess(state, action) {
      state.events = action.payload;
    },

    // UPDATE EVENT
    updateEventSuccess(state, action) {
      state.events = action.payload;
    },

    // REMOVE EVENT
    removeEventSuccess(state, action) {
      state.events = action.payload;
    },

    resetCalendar() {
      return initialState;
    },
  },
});

// Reducer
export default slice.reducer;
export const { resetCalendar } = slice.actions;

// ==============================|| SLICE - CALENDAR ACTIONS ||============================== //

export function getEvents() {
  return async () => {
    try {
      // const response = await axios.get(hostDomain + '/api/calendar/events', config);
      // dispatch(slice.actions.getEventsSuccess(response.data.events));
      dispatch(
        slice.actions.getEventsSuccess([
          {
            id: '5e8882f1f0c9216397e05a9b',
            allDay: false,
            color: '#f5222d',
            description: 'SCRUM Planning',
            start: '2025-05-19T11:04:34.328Z',
            end: '2025-05-19T13:19:34.328Z',
            title: 'Repeating Event',
          },
          {
            id: '5e8882fcd525e076b3c1542c',
            allDay: true,
            color: '#faad14',
            description: 'Sorry, John!',
            start: '2025-05-23T16:04:34.328Z',
            end: '2025-05-23T16:19:34.328Z',
            title: 'Conference',
          },
          {
            id: '5e8882e440f6322fa399eeb8',
            allDay: true,
            color: '#52c41a',
            description: 'Inform about new contract',
            start: '2025-06-28T16:49:34.328Z',
            end: '2025-06-27T16:49:34.328Z',
            title: 'All Day Event',
          },
          {
            id: '5e8882fcd525e076b3c1542d',
            allDay: false,
            color: '#f6ffed',
            textColor: '#52c41a',
            description: 'Sorry, Stebin Ben!',
            start: '2025-06-01T11:49:34.328Z',
            end: '2025-06-01T15:19:34.329Z',
            title: 'Opening Ceremony',
          },
          {
            id: '5e8882eb5f8ec686220ff138',
            allDay: true,
            color: '#8c8c8c',
            description: 'Discuss about new partnership',
            start: '2025-06-27T16:49:34.329Z',
            end: '2025-06-01T15:49:34.329Z',
            title: 'Long Event',
          },
          {
            id: '5e88830672d089c53c46ece3',
            allDay: false,
            description: 'Get a new quote for the payment processor',
            start: '2025-06-03T06:30:34.329Z',
            end: '2025-06-03T08:30:34.329Z',
            title: 'Breakfast',
          },
          {
            id: '5e888302e62149e4b49aa609',
            allDay: false,
            color: '#fffbe6',
            textColor: '#faad14',
            description: 'Discuss about the new project',
            start: '2025-04-03T09:45:34.329Z',
            end: '2025-04-03T15:30:34.329Z',
            title: 'Meeting',
          },
          {
            id: '5e888302e62149e4b49aa709',
            allDay: false,
            color: '#f5222d',
            description: "Let's Go",
            start: '2025-04-03T09:00:34.329Z',
            end: '2025-04-03T11:30:34.329Z',
            title: 'Anniversary Celebration',
          },
          {
            id: '5e888302e69651e4b49aa609',
            allDay: false,
            description: 'Discuss about the new project',
            start: '2025-05-04T22:14:34.329Z',
            end: '2025-05-04T22:44:34.329Z',
            title: 'Send Gift',
          },
          {
            id: '5e8883062k8149e4b49aa709',
            allDay: false,
            color: '#faad14',
            description: "Let's Go",
            start: '2025-05-04T20:34:34.329Z',
            end: '2025-05-04T22:04:34.329Z',
            title: 'Birthday Party',
          },
          {
            id: '5e8882f1f0c9216396e05a9b',
            allDay: false,
            color: '#8c8c8c',
            description: 'SCRUM Planning',
            start: '2025-05-04T20:19:34.329Z',
            end: '2025-05-04T21:19:34.329Z',
            title: 'Repeating Event',
          },
          {
            id: '5e888302e62149e4b49aa610',
            allDay: false,
            color: '#f5222d',
            description: "Let's Go",
            start: '2025-05-04T20:34:34.329Z',
            end: '2025-05-04T21:39:34.329Z',
            title: 'Dinner',
          },
          {
            id: '5e8882eb5f8ec686220ff131',
            allDay: true,
            description: 'Discuss about new partnership',
            start: '2025-05-08T16:49:34.329Z',
            end: '2025-05-11T17:49:34.329Z',
            title: 'Long Event',
          },
          {
            id: '5e888302e62349e4b49aa609',
            allDay: false,
            color: '#1890ff',
            textColor: '#e6f7ff',
            description: 'Discuss about the project launch',
            start: '2025-05-09T17:04:34.329Z',
            end: '2025-05-09T17:09:34.329Z',
            title: 'Meeting',
          },
          {
            id: '5e888302e62149e4b49ab609',
            allDay: false,
            color: '#52c41a',
            description: 'Discuss about the tour',
            start: '2025-05-15T20:34:34.329Z',
            end: '2025-05-15T21:39:34.329Z',
            title: 'Happy Hour',
          },
        ]),
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addEvent(event: FormikValues) {
  return async () => {
    try {
      const response = await axios.post(hostDomain + '/api/calendar/events/add', event, config);
      dispatch(slice.actions.addEventSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateEvent(event: FormikValues) {
  return async () => {
    try {
      const response = await axios.post(hostDomain + '/api/calendar/events/update', event, config);
      dispatch(slice.actions.updateEventSuccess(response.data.events));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function removeEvent(eventId: string) {
  return async () => {
    try {
      const response = await axios.post(hostDomain + '/api/calendar/events/delete', { eventId }, config);
      dispatch(slice.actions.removeEventSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
